import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"items":_vm.projectNames,"label":_vm.labelValue,"clearable":_vm.clearable ? _vm.clearable : false,"readonly":_vm.readonly,"hide-details":_vm.hideDetails ? _vm.hideDetails : false,"outlined":""},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }